import { Injectable, Output } from '@angular/core';
import { FiltroProductosModel } from '../Modelo/Filtro_Productos.model';
import { SerieModel } from '../Modelo/Serie.model';
import { SortProductsModel } from '../Modelo/Sort_Products.model';
import { vProductoModel } from '../Modelo/vProducto.model';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    public FiltroProductos: FiltroProductosModel = new FiltroProductosModel();
    public ListaProductos: vProductoModel[] = [];
    public SortProducts: SortProductsModel = new SortProductsModel();
	public ListaSeries: SerieModel[] = [];
    private _isSearching: boolean = false;
    isSearchingProducts: boolean;

    @Output() ListaProductosChange

    get isSearching(): boolean {
        return this._isSearching;
    }

    set isSearching(isSearching: boolean) {
        this._isSearching = isSearching;
    }

    constructor() {
        this.isSearchingProducts = false;
    }

    public BuscarProductos(): void {
        console.log(this.FiltroProductos);
    }
}